import { Injectable } from '@angular/core';
import { BaseApi } from './base/base-api';
import { environment } from '../../../environments/environment';
import { ImportAlarmMaskRequest } from '../../../shared/models/alarm-mask/import-alarm-mask-request';
import { Observable } from 'rxjs';
import { AlarmMaskImportStatusRequest } from '../../../shared/models/alarm-mask/alarm-mask-import-status-request';
import { AlarmMaskImportStatus } from '../../../shared/models/alarm-mask/alarm-mask-import-status';
import { ImportAlarmMaskTranslationRequest } from '../../../shared/models/alarm-mask/import-alarm-mask-translation-request';
import { AlarmMaskTranslationImportStatus } from '../../../shared/models/alarm-mask/alarm-mask-translation-import-status';
import { ImportReport } from '../../../shared/models/report/import-report';

@Injectable({
  providedIn: 'root',
})
export class AlarmMaskApiService extends BaseApi {
  constructor() {
    super(environment.api + 'alarmmask');
  }

  public importAlarmMask(importAlarmMaskRequest: ImportAlarmMaskRequest): Observable<ImportReport> {
    const formData = new FormData();
    if (importAlarmMaskRequest.xmlFile) {
      formData.append('xmlFile', importAlarmMaskRequest.xmlFile);
    }
    return this.http.post<ImportReport>(this.baseUrl + '/import/' + importAlarmMaskRequest.projectId, formData);
  }

  public getImportStatus(
    alarmMaskImportStatusRequest: AlarmMaskImportStatusRequest
  ): Observable<AlarmMaskImportStatus> {
    const formData = new FormData();
    if (alarmMaskImportStatusRequest.xmlFile) {
      formData.append('xmlFile', alarmMaskImportStatusRequest.xmlFile);
    }
    return this.http.post<AlarmMaskImportStatus>(
      this.baseUrl + '/import-status/' + alarmMaskImportStatusRequest.projectId,
      formData
    );
  }

  public getImportTranslationStatus(
    importAlarmMaskTranslationRequest: ImportAlarmMaskTranslationRequest
  ): Observable<AlarmMaskTranslationImportStatus> {
    const formData = new FormData();
    if (!importAlarmMaskTranslationRequest.xmlFiles) {
      throw 'No xml files selected';
    }
    importAlarmMaskTranslationRequest.xmlFiles.forEach((file) => formData.append('xmlFiles', file));
    return this.http.post<AlarmMaskTranslationImportStatus>(
      this.baseUrl + '/import-translation-status/' + importAlarmMaskTranslationRequest.projectId,
      formData
    );
  }

  public importAlarmMaskTranslations(
    importAlarmMaskTranslationRequest: ImportAlarmMaskTranslationRequest
  ): Observable<ImportReport> {
    const formData = new FormData();
    if (!importAlarmMaskTranslationRequest.xmlFiles) {
      throw 'No xml files selected';
    }
    importAlarmMaskTranslationRequest.xmlFiles.forEach((file) => formData.append('xmlFiles', file));
    return this.http.post<ImportReport>(
      this.baseUrl + '/import-translation/' + importAlarmMaskTranslationRequest.projectId,
      formData
    );
  }
}
